import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(4),
    borderBottom: `1px solid #585958;`,
    paddingBottom: theme.spacing(1),
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    color: theme.palette.text.primary,
    fontSize: '0.75rem',
    fontWeight: 500,
    alignItems: 'center',
  },
  mobileRow: {
    padding: '0 10px 0 10px',
  },
  iconMobile: {
    position: 'absolute',
    right: 10,
    top: '40%',
  },
  printBtn: {
    position: 'absolute',
    top: 72,
  },
  red: {
    color: theme.colors.redIcon,
  },
  orange: {
    color: theme.colors.orangeIcon,
  },
  grey: {
    color: theme.colors.greyIcon,
  },
  padLeft: {
    paddingLeft: theme.spacing(1),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
}));

export default useStyles;
